import React from "react";

export default function ActiveFilter({children}) {
    return (
        <>
            {children}
        </>
    )
}